<div class="page-container connection-list-container">
  <app-grid-users-list
    [constructorData]="constructorData"
    [isLoading]="isLoading"
    [noUsersHint]="'REGULAR_USER_NO_CONNECTIONS_YET'"
    [pagination]="true"
    [pageSize]="defaultCount"
    [currentPage]="searchState.pagination.currentPage"
    [totalCount]="searchState.pagination?.totalItemsCount"
    (pageChange)="onPageChanged($event)"
  ></app-grid-users-list>
</div>
